import { FC } from "react";
import { Box, Center, HStack, Skeleton, Stack, Text } from "@chakra-ui/react";

import { useSbpTransferStore } from "../../../../../../store/sbpTransferStore.ts";
import { SbpTransferPagePaymentTimeline } from "./SbpTransferPagePaymentTimeline.tsx";
import { useSbpTransferScheduleQuery } from "../../../../../../api/sbpTransfer/hooks";
import { formatPriceWithoutZeros, getPaymentWord, isStringWithNumber } from "../../../../../../utils";

export const SbpTransferPageScheduleContent: FC = () => {
  const { data, isFetching, isError } = useSbpTransferScheduleQuery();
  const term = useSbpTransferStore(s => s.term);

  const condition = `Раз в месяц, ${term?.term || ""} ${getPaymentWord(term?.term ?? 0)}`;
  const paymentToday = formatPriceWithoutZeros(0);

  const firstPayment = data?.offers?.[0]?.scheduleItems?.find(item => item.idx === 0)?.total;
  const paymentMonthly = isStringWithNumber(firstPayment) ? formatPriceWithoutZeros(Number(firstPayment)) : "";

  if (isFetching) {
    return (
      <Stack spacing={1} mt="19px" mb="1px">
        <Skeleton h="14px" />
        <Skeleton h="14px" />
        <Skeleton h="14px" />
      </Stack>
    );
  }

  if (isError || !firstPayment) {
    return (
      <Center h="57px">
        <Text fontSize="14px">Не удалось загрузить график</Text>
      </Center>
    );
  }

  return (
    <Box mt="28px">
      <SbpTransferPagePaymentTimeline />

      <HStack mb="5px" justifyContent="space-between" fontSize="12px" lineHeight="1">
        <Text>Сейчас</Text>
        <Text>{condition}</Text>
      </HStack>

      <HStack mb="2px" justifyContent="space-between" fontFamily="Normalidad Medium Var" fontSize="12px" lineHeight="1">
        <Text variant="brand">{paymentToday}</Text>
        <Text variant="brand">{paymentMonthly}</Text>
      </HStack>
    </Box>
  );
};
